import { privacyCenterActionTypes } from './privacyCenter.constants';
import { dsrUpdateStatuses } from './dsr/dsr.helpers';

const initialState = {
    services: [],
    activeServiceUuid: undefined,
    dsrFormOpen: false,
    deleting: false,
    gettingServicesAndConsentsStatus: true,
    showDSRDeleteStatusInfo: {},
    socialUnlinkFormOpen: false,
    activeSocialProvider: null,
    activeSocialProviderName: null,
    activeSocialUnlinkTargetId: null,
    unlinkingSocial: false,
};

export const mergeByProperty = (target, source, prop) => {
    const result = [];

    target.forEach((targetElement) => {
        let updated = false;
        if (targetElement[prop] === source[prop]) {
            result.push(source);
            updated = true;
        }
        if (!updated) {
            result.push(targetElement);
        }
    });
    return result;
};

export function privacyCenterReducer(state = initialState, action) {
    switch (action.type) {
        case privacyCenterActionTypes.LOAD_SERVICES_CONFIG_REQUEST:
            return { ...state, loadingServicesConfig: true, loadingServicesConfigError: null };
        case privacyCenterActionTypes.LOAD_SERVICES_CONFIG_SUCCESS:
            return {
                ...state,
                servicesConfig: action.servicesConfig,
                loadingServicesConfig: false,
            };
        case privacyCenterActionTypes.LOAD_SERVICES_CONFIG_FAILURE:
            return {
                ...state,
                loadingServicesConfigError: action.error,
                loadingServicesConfig: false,
            };
        case privacyCenterActionTypes.LOAD_SERVICES_RECOMMENDATION_REQUEST:
            return {
                ...state,
                loadingServiceRecommendations: true,
                loadingServiceRecommendationsError: null,
            };
        case privacyCenterActionTypes.LOAD_SERVICES_RECOMMENDATION_SUCCESS:
            return {
                ...state,
                recommendations: action.recommendations,
                loadingServiceRecommendations: false,
            };
        case privacyCenterActionTypes.LOAD_SERVICES_RECOMMENDATION_FAILURE:
            return {
                ...state,
                loadingServiceRecommendationsError: action.error,
                loadingServiceRecommendations: false,
            };
        case privacyCenterActionTypes.GET_SERVICES_AND_CONSENTS_REQUEST:
            return { ...state, gettingServicesAndConsentsStatus: true };
        case privacyCenterActionTypes.GET_SERVICES_AND_CONSENTS_FAILURE:
            return {
                ...state,
                gettingServicesAndConsentsStatus: false,
                gettingServicesAndConsentsStatusError: action.error,
            };

        case privacyCenterActionTypes.GET_SERVICES_AND_CONSENTS_SUCCESS:
            return {
                ...state,
                gettingServicesAndConsentsStatus: false,
                services: action.servicesAndConsentsStatus,
            };
        case privacyCenterActionTypes.UPDATE_CONSENT_REQUEST:
            return {
                ...state,
                services: state.services.map((item) => {
                    if (item.serviceUuid !== action.data.serviceUuid) {
                        return item;
                    }

                    return {
                        ...item,
                        updating: true,
                        updated: false,
                    };
                }),
            };
        case privacyCenterActionTypes.UPDATE_CONSENT_SUCCESS:
            return {
                ...state,
                services: mergeByProperty(state.services, action.response.services, 'serviceUuid'),
            };
        case privacyCenterActionTypes.UPDATE_CONSENT_FAILURE:
            return {
                ...state,
                services: state.services.map((item) => {
                    if (item.serviceUuid !== action.payload.serviceUuid) {
                        return item;
                    }

                    return {
                        ...item,
                        updating: false,
                    };
                }),
            };
        case privacyCenterActionTypes.CANCEL_MEMBERSHIP_REQUEST:
            return {
                ...state,
                deletingAccount: true,
            };
        case privacyCenterActionTypes.CANCEL_MEMBERSHIP_SUCCESS:
            return {
                ...state,
                deletingAccount: false,
            };
        case privacyCenterActionTypes.CANCEL_MEMBERSHIP_FAILURE:
            return {
                ...state,
                errorDeletingAccount: action.error,
                deletingAccount: false,
            };
        case privacyCenterActionTypes.OPEN_DSR_FORM: {
            return {
                ...state,
                activeServiceUuid: action.serviceUuid,
                dsrFormOpen: true,
            };
        }
        case privacyCenterActionTypes.CLOSE_DSR_FORM: {
            return {
                ...state,
                activeServiceUuid: null,
                dsrFormOpen: false,
            };
        }
        case privacyCenterActionTypes.DELETE_SERVICE_BTN_REQUEST: {
            return {
                ...state,
                deleting: true,
            };
        }
        case privacyCenterActionTypes.DELETE_SERVICE_BTN_SUCCESS: {
            return {
                ...state,
                deleting: false,
                activeServiceUuid: null,
                dsrFormOpen: false,
                dsrStatuses: dsrUpdateStatuses(state.dsrStatuses, action.data),
            };
        }
        case privacyCenterActionTypes.DELETE_SERVICE_BTN_FAILED: {
            return {
                ...state,
                deleting: false,
            };
        }
        case privacyCenterActionTypes.TOGGLE_DSR_DELETE_STATUS_INFO:
            return {
                ...state,
                showDSRDeleteStatusInfo: { [action.serviceUuid]: action.value },
            };
        case privacyCenterActionTypes.OPEN_SOCIAL_UNLINK_FORM:
            return {
                ...state,
                socialUnlinkFormOpen: true,
                activeSocialProvider: action.providerId,
                activeSocialProviderName: action.providerName,
                activeSocialUnlinkTargetId: action.unlinkTargetId,
            };
        case privacyCenterActionTypes.CLOSE_SOCIAL_UNLINK_FORM:
            return {
                ...state,
                socialUnlinkFormOpen: false,
                activeSocialProvider: null,
                activeSocialProviderName: null,
                activeSocialUnlinkTargetId: null,
            };
        case privacyCenterActionTypes.UNLINK_SOCIAL_PROVIDER_REQUEST:
            return {
                ...state,
                unlinkingSocial: true,
            };
        case privacyCenterActionTypes.UNLINK_SOCIAL_PROVIDER_SUCCESS:
            return {
                ...state,
                unlinkingSocial: false,
                socialUnlinkFormOpen: false,
                activeSocialProvider: null,
                activeSocialProviderName: null,
                activeSocialUnlinkTargetId: null,
            };
        case privacyCenterActionTypes.UNLINK_SOCIAL_PROVIDER_FAILURE:
            return {
                ...state,
                unlinkingSocial: false,
            };
        default:
            return state;
    }
}
